export default __webpack_public_path__ + "static/media/logo-cakedefi-compact.2b721807.svg";